module.exports = __webpack_public_path__ + "ng2-emoji.ba262dbfbcdab9e82a16.png";


//////////////////
// WEBPACK FOOTER
// /home/travis/build/AhsanAyaz/ng2-emoji/example/~/ng2-emoji/img/ng2-emoji.png
// module id = ../../../../ng2-emoji/img/ng2-emoji.png
// module chunks = 3